var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useRef } from 'react';
const DEFAULT_ICON = '/favicons/android-chrome-192x192.jpg';
const isNotificationSupported = () => typeof window !== 'undefined' && 'Notification' in window;
export function useBrowserNotification() {
    const notificationRef = useRef(null);
    const requestPermission = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        if (!isNotificationSupported())
            return;
        if (Notification.permission === 'granted')
            return;
        if (Notification.permission === 'denied')
            return;
        yield Notification.requestPermission();
    }), []);
    const sendNotification = useCallback(({ title, body, icon, onClick }) => {
        if (!isNotificationSupported())
            return;
        if (Notification.permission !== 'granted')
            return;
        if (notificationRef.current) {
            notificationRef.current.close();
        }
        const notification = new Notification(title, {
            body,
            icon: icon !== null && icon !== void 0 ? icon : DEFAULT_ICON,
        });
        notification.onclick = () => {
            window.focus();
            onClick === null || onClick === void 0 ? void 0 : onClick();
            notification.close();
        };
        notificationRef.current = notification;
    }, []);
    return { requestPermission, sendNotification };
}
